// dependencies
import { Map, fromJS } from "immutable";

import moment from "../utils/Momentize";

// utils

const initialState = fromJS({
	cycles: Map(),
	reviewReports: Map(),
});

export default function ReviewsReducer(state = initialState, action) {
	switch (action.type) {
		case "REVIEWS:CYCLE.PROGRESS@RESPONSE": {
			return state.setIn(["cycles", action.cycleId, "progress", action.functionName], action.progress);
		}

		case "REVIEWS:CYCLE.GET@RESPONSE": {
			return state.withMutations((mutable) => {
				mutable.setIn(["cycles", action.cycleId, "name"], action.data.name);
				mutable.setIn(["cycles", action.cycleId, "group"], action.data.group);
				mutable.setIn(["cycles", action.cycleId, "template"], action.data.template);
				mutable.setIn(["cycles", action.cycleId, "reviewCount"], action.data.count);
				mutable.setIn(["cycles", action.cycleId, "hasStarted"], action.data.started);
				mutable.setIn(["cycles", action.cycleId, "isClosing"], action.data.is_closing);
				mutable.setIn(["cycles", action.cycleId, "startDate"], moment(action.data.start_date));
				mutable.setIn(
					["cycles", action.cycleId, "dueDate"],
					action.data.due_date ? moment(action.data.due_date) : ""
				);
				mutable.setIn(["cycles", action.cycleId, "hasEasyAdd"], moment(action.data.has_easy_add));
			});
		}

		case "REVIEWS:CYCLE.FILTER@RESPONSE": {
			const reviews = action.reviews.map((review) => {
				/*
                    loop through the reviews
                */

				const isAdminsOnly = !!review.admins_only;

				return {
					...review,
					isAdminsOnly,
					hasExternal: review.external > 0,
					due_date: moment(review.due_date),
					complete_date: moment(review.complete_date),
					hasUnassignedReports: review.unassigned_reports > 0,
					external: review.external > 0 ? review.external : "",
					unassigned: review.unassigned > 0 ? review.unassigned : "",
				};
			});

			return state.withMutations((mutable) => {
				mutable.setIn(["cycles", action.cycleId, "reviews"], fromJS(reviews));
				mutable.setIn(["cycles", action.cycleId, "filteredCount"], action.reviewsCount);
			});
		}

		case "REVIEWS:CYCLE.BUILDING": {
			return state.withMutations((mutable) => {
				mutable.setIn(["cycles", action.cycleId, "buildingProgress", "total"], action.update.total);
				mutable.setIn(["cycles", action.cycleId, "buildingProgress", "complete"], action.update.progress);
				mutable.setIn(
					["cycles", action.cycleId, "buildingProgress", "progress"],
					parseInt((action.update.progress / action.update.total) * 100, 10)
				);
			});
		}

		case "REVIEWS:CYCLE.UPDATE_SELECTION_OBJECTS": {
			return state.withMutations((mutable) => {
				mutable.setIn(["cycles", action.cycleId, "newSelectionObject"], action.new);
				mutable.setIn(
					["cycles", action.cycleId, "existingSelectionObjects"],
					action.existing.length ? action.existing[0] : null
				);
			});
		}

		case "REVIEWS:CYCLE.MARK_AS_DELETED": {
			return state.setIn(["cycles", action.cycleId], Map({ _deleted: true }));
		}

		case "REVIEWS:CYCLE.MARK_AS_CLOSED": {
			return state.setIn(["cycles", action.cycleId, "isClosing"], true);
		}

		case "REVIEWS:REPORT.GETSINGLE@SUCCESS": {
			return state.setIn(["reviewReports", action.request.props.reportID], action.response);
		}

		default:
			// never forget your default return state!
			return state;
	}
}
